/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared theme layout. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
  function rdFormat(text, values) { return text.replace(/{{\s*(\w+)\s*}}|\[(\w+)\]/g, function (match, name, token) { name = name || token; return Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match; }); }
/* Capkov redesign, round 2 (EU): builder wrapper (UI only on top of the capkov-builder.js engine, does not change its logic).
   1) prefill from the homepage hero (?rd_text=&rd_thread=&rd_open=1; cap colour goes via ?variant=),
   2) clickable steps 1-2-3 (scroll to the matching part),
   3) price right in the "Add to cart" button (data-rd-price attribute, rendered by CSS),
   4) the "Get help with your design" block stays in the HTML snippet. */
(function () {
  'use strict';
  var qs = new URLSearchParams(location.search);
  var preText = qs.get('rd_text'), preThread = qs.get('rd_thread'), preOpen = qs.get('rd_open'), preStep = qs.get('rd_step');

  function $(s, r) { return (r || document).querySelector(s); }
  function modal() { return $('[data-capkov-modal]'); }

  /* ---- 1) prefill ---- */
  function prefill() {
    if (!preText && !preOpen) return;
    var btn = $('[data-capkov-open]');
    if (!btn) return;
    var tries = 0, done = false;
    btn.click();
    (function wait() {
      if (done) return;
      var ta = $('[data-capkov-text]');
      var vis = ta && ta.offsetParent !== null;
      if (!vis && tries++ < 40) { setTimeout(wait, 150); return; }
      done = true;
      if (ta && preText) {
        ta.value = preText; ta.dispatchEvent(new Event('input', { bubbles: true })); ta.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (preThread) {
        var want = preThread === 'black' ? 'Black' : (preThread === 'white' ? 'White' : preThread); /* or a thread colour name from the builder (e.g. Gold); the EU engine uses English colour labels */
        var c = $('[data-capkov-colors] .capkov-b2__color[data-color="' + want + '"]');
        if (c && c.getAttribute('data-active') !== 'true') c.click();
      }
      if (preStep === 'upload') { /* wizard „Obrázek nebo logo“: builder otevřený na nahrání souboru */
        setTimeout(function () { var f = $('[data-capkov-file]'); var box = f && (f.closest('.capkov-b2__field,.capkov-b2__row,label,div') || f); if (box && box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' }); if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e) { } } }, 450);
      }
      try {
        var u = new URL(location.href);
        ['rd_text', 'rd_thread', 'rd_open', 'rd_step'].forEach(function (k) { u.searchParams.delete(k); });
        history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
      } catch (e) { }
    })();
  }
  if (preText || preOpen) {
    if (window.__capkovBuilderInit && document.querySelector('[data-capkov-inited="1"]')) setTimeout(prefill, 50);
    else document.addEventListener('capkov:builder-ready', function () { setTimeout(prefill, 80); }, { once: true });
  }

  /* ---- 2) kroky 1-2-3: klikací + skutečný stav (hotovo = platné vstupy A uživatel už je dál) ---- */
  var CFG = {};
  try { CFG = JSON.parse(($('[data-capkov-config]') || {}).textContent || '{}'); } catch (e) { }
  function scrollerOf(m) { return $('[data-capkov-scroll]', m); }
  function stepTargets(m) {
    var sc = scrollerOf(m);
    return [
      $('[data-capkov-placements]', m) || (sc && sc.firstElementChild),
      $('[data-capkov-thread-row]', m),
      $('[data-capkov-actions]', m) || $('[data-capkov-add]', m)
    ];
  }
  function focusStep(m, i) {
    var el = null;
    if (i === 0) el = $('[data-capkov-text]', m);
    else if (i === 1) el = $('.capkov-b2__color[data-active="true"]', m) || $('[data-capkov-colors] .capkov-b2__color', m);
    else el = $('[data-capkov-add]', m);
    if (el && el.offsetParent !== null && !el.disabled) { try { el.focus({ preventScroll: true }); } catch (e) { } }
  }
  function scrollToStep(i) {
    var m = modal(); if (!m) return;
    var sc = scrollerOf(m); if (!sc) return;
    var target = stepTargets(m)[i];
    if (i === 2 || !target) { sc.scrollTo({ top: sc.scrollHeight, behavior: 'smooth' }); return; }
    var steps = $('[data-rd-bsteps]', m);
    var off = steps ? steps.offsetHeight + 8 : 0;
    var top = target.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - off;
    sc.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }
  var stepState = { manual: 0, mode: 'manual' };
  function stepValid(m, i) {
    var filled = m.querySelectorAll('[data-capkov-tabs] .capkov-b2__tab[data-capkov-filled="true"]').length > 0;
    var ta = $('[data-capkov-text]', m), fi = $('[data-capkov-fileinfo]', m);
    var v1 = filled || !!(ta && ta.offsetParent !== null && ta.value.trim()) || !!(fi && !fi.hidden && fi.offsetParent !== null);
    if (i === 0) return v1;
    var row = $('[data-capkov-thread-row]', m);
    var v2 = v1 && (!row || row.hidden || !!row.querySelector('.capkov-b2__color[data-active="true"]'));
    return i === 1 ? v2 : v2;
  }
  function currentStep(m) {
    if (stepState.mode === 'manual') return stepState.manual;
    var sc = scrollerOf(m); if (!sc) return 0;
    var steps = $('[data-rd-bsteps]', m), stepsH = steps ? steps.offsetHeight : 0;
    var r = sc.getBoundingClientRect(), vis = sc.clientHeight - stepsH;
    var scrollable = sc.scrollHeight - sc.clientHeight > 40;
    if (scrollable && sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 12) return 2;
    var th = $('[data-capkov-thread-row]', m);
    if (th && !th.hidden && th.offsetParent !== null) {
      var pos = th.getBoundingClientRect().top - r.top - stepsH;
      if (pos < vis * 0.5) return 1;
    }
    return 0;
  }
  var stepRaf = 0;
  function paintSteps() {
    stepRaf = 0;
    var m = modal(); if (!m) return;
    var steps = $('[data-rd-bsteps]', m); if (!steps) return;
    steps.setAttribute('data-rd-own', '1');
    var li = steps.children, cur = currentStep(m);
    for (var i = 0; i < li.length; i++) {
      var ok = i < 2 ? stepValid(m, i) : stepValid(m, 1);
      var st = i === cur ? 'active' : (i < cur ? (ok ? 'done' : 'attn') : '');
      li[i].setAttribute('data-state', st);
      if (i === cur) li[i].setAttribute('aria-current', 'step'); else li[i].removeAttribute('aria-current');
      if (!li[i].hasAttribute('tabindex')) { li[i].setAttribute('tabindex', '0'); li[i].setAttribute('role', 'button'); }
      li[i].setAttribute('title', st === 'attn' ? rdOT("capkov.builder.fill_this_in_first", "Fill this in first") : rdOT("capkov.builder.jump_to_this_step", "Jump to this step"));
    }
  }
  function schedSteps() { if (!stepRaf) stepRaf = requestAnimationFrame(paintSteps); }
  function jump(li) {
    var all = [].slice.call(li.parentNode.children), i = all.indexOf(li), m = modal();
    stepState.manual = i; stepState.mode = 'manual';
    scrollToStep(i); focusStep(m, i); paintSteps();
    setTimeout(function () { if (stepState.mode === 'manual' && stepState.manual === i) { stepState.mode = 'scroll'; schedSteps(); } }, 700);
  }
  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('[data-rd-bsteps] li');
    if (li) jump(li);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var li = e.target.closest && e.target.closest('[data-rd-bsteps] li');
    if (li) { e.preventDefault(); jump(li); }
  });
  function bindSteps() {
    var m = modal(); if (!m || m.__rdSteps) return; m.__rdSteps = 1;
    var sc = scrollerOf(m);
    if (sc) sc.addEventListener('scroll', function () { stepState.mode = 'scroll'; schedSteps(); }, { passive: true });
    function inSec(t, sel) { var el = $(sel, m); return !!(el && t && el.contains(t)); }
    function onInteract(e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-rd-bsteps]')) return;
      var k = null;
      if (inSec(t, '[data-capkov-thread-row]')) k = 1;
      else if (inSec(t, '[data-capkov-actions]') || (t.closest && t.closest('[data-capkov-add]'))) k = 2;
      else if (inSec(t, '[data-capkov-placements]') || inSec(t, '[data-capkov-text-ui]') || inSec(t, '[data-capkov-font-ui]') || inSec(t, '[data-capkov-image-ui]')) k = 0;
      if (k !== null) { stepState.manual = k; stepState.mode = 'manual'; }
      schedSteps();
    }
    m.addEventListener('focusin', onInteract, true);
    m.addEventListener('click', onInteract, true);
    m.addEventListener('input', schedSteps, true);
    if (window.MutationObserver) new MutationObserver(schedSteps).observe(m, { attributes: true, childList: true, subtree: true, attributeFilter: ['data-active', 'data-capkov-filled', 'hidden', 'data-open'] });
    window.addEventListener('resize', schedSteps);
    paintSteps();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSteps, { once: true }); else bindSteps();
  document.addEventListener('capkov:builder-ready', function () { bindSteps(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-capkov-open]')) { stepState.manual = 0; stepState.mode = 'manual'; setTimeout(function () { bindSteps(); paintSteps(); }, 80); } }, true);

  /* ---- 2b) vysvětlení limitu znaků (engine píše jen „max 14 / 14 / 14“ nebo „max 8“) ---- */
  function explainLimit() {
    var m = modal(), el = m && $('[data-capkov-text-limit]', m); if (!el) return;
    var raw = (el.getAttribute('data-rd-raw') !== null && el.textContent === el.getAttribute('data-rd-out')) ? el.getAttribute('data-rd-raw') : el.textContent;
    if (!/^\s*max\s+\d/i.test(raw) || /•|chars|znaků na řádek/i.test(raw)) return;
    var nums = (raw.match(/\d+/g) || []).map(Number), act = $('[data-capkov-tabs] .capkov-b2__tab[data-active="true"]', m), pl = (act && act.getAttribute('data-placement')) || 'front', out;
    if (nums.length > 1) {
      var same = nums.every(function (x) { return x === nums[0]; });
      out = (same ? rdFormat(rdOT("capkov.builder.up_to_count_characters_per_line_max_lines_lines", "up to {{ count }} characters per line, max {{ lines }} lines"), {count: nums[0], lines: nums.length}) : rdFormat(rdOT("capkov.builder.characters_per_line_limits", "characters per line: {{ limits }}"), {limits: nums.join(' / ')}));
    } else {
      var n = nums[0];
      if (pl === 'back' && !document.querySelector('[data-capkov-mode*="winter"]')) out = rdFormat(rdOT("capkov.builder.back_max_count_characters_smaller_area", "Back: max {{ count }} characters (smaller area)"), {count: n});
      else if (pl === 'side_left' || pl === 'side_right') out = rdFormat(rdOT("capkov.builder.side_max_count_characters_smaller_area", "Side: max {{ count }} characters (smaller area)"), {count: n});
      else out = rdFormat(rdOT("capkov.builder.max_count_characters", "max {{ count }} characters"), {count: n});
    }
    if (out && el.textContent !== out) { el.setAttribute('data-rd-raw', raw); el.setAttribute('data-rd-out', out); el.textContent = out; }
  }
  function bindLimit() {
    var m = modal(), el = m && $('[data-capkov-text-limit]', m);
    if (!el || el.__rdLim) return; el.__rdLim = 1;
    explainLimit();
    if (window.MutationObserver) new MutationObserver(explainLimit).observe(el, { childList: true, characterData: true, subtree: true });
    m.addEventListener('click', function () { setTimeout(explainLimit, 30); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindLimit, { once: true }); else bindLimit();
  document.addEventListener('capkov:builder-ready', function () { setTimeout(bindLimit, 60); });

  /* ---- 2c) pozadí fotek zezadu / ze boku: stejné jako zepředu (násobení na #f4f4f2), u černé čepice bez modrošedého nádechu ---- */
  function stageImg(m) { return $('[data-capkov-stage] img[data-capkov-base]', m); }
  function activePlacement(m) { var a = $('[data-capkov-tabs] .capkov-b2__tab[data-active="true"]', m); return (a && a.getAttribute('data-placement')) || 'front'; }
  function swatchNeutral(m) {
    /* 7. 10.: neutralizační filtr (u černých čepic bez modrošedého nádechu) NESMÍ na dvoubarevné (two-tone) čepice – tečka je tmavá (kšilt), ale čepice je krémová a filtr ji zešednul. Rozhoduje režim builderu i soubor fotky. */
    var mk = (m.getAttribute('data-capkov-mode') || ((m.closest && m.closest('[data-capkov-mode]')) || m.querySelector('[data-capkov-mode]') || {getAttribute:function(){return ''}}).getAttribute('data-capkov-mode') || '');
    var bi = stageImg(m); if (/two_tone/.test(mk) || (bi && /twotone/i.test(bi.getAttribute('src') || ''))) return false;
    var sw = $('.capkov-b2__swatch[data-active="true"]', m); if (!sw) return false;
    var c = (getComputedStyle(sw).backgroundColor || '').match(/\d+/g); if (!c || c.length < 3) return false;
    var r = +c[0] / 255, g = +c[1] / 255, b = +c[2] / 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b);
    return mx < 0.45 && (mx - mn) < 0.12;
  }
  function paintStage() {
    var m = modal(), img = m && stageImg(m); if (!img) return;
    var pl = activePlacement(m), angled = pl !== 'front' && !document.querySelector('[data-capkov-mode*="winter"]');   /* zimní čepice: zadek = stejná fotka jako předek */
    img.setAttribute('data-rd-view', angled ? 'angle' : 'front');
    img.setAttribute('data-rd-neutral', angled && swatchNeutral(m) ? '1' : '0');
  }
  function bindStage() {
    var m = modal(); if (!m || m.__rdStage) return; m.__rdStage = 1;
    var raf = 0; function s() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; paintStage(); }); }
    if (window.MutationObserver) new MutationObserver(s).observe(m, { attributes: true, subtree: true, attributeFilter: ['data-active', 'src', 'data-open'] });
    paintStage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindStage, { once: true }); else bindStage();
  document.addEventListener('capkov:builder-ready', function () { setTimeout(bindStage, 60); });

  /* ---- 2d) třída pro celostránkové překryvy (chatová bublina atd.): body.rd-modal-open při otevřeném builderu ---- */
  function bindOpenClass() {
    var m = modal(); if (!m || m.__rdOpenCls || !window.MutationObserver) return; m.__rdOpenCls = 1;
    /* plovoucí kulatá bublina (chat apod.) nesmí překrývat obsah builderu: při otevřeném okně ji schováme a po zavření vrátíme */
    var floHid = [], floTimer = 0, floOn = false;
    function floScan() {
      var W = window.innerWidth, Hh = window.innerHeight, kids = [];
      [].slice.call(document.body.children).forEach(function (c) { kids.push(c); [].slice.call(c.children).forEach(function (d) { kids.push(d); }); });
      kids.forEach(function (el) {
        try {
          if (!el.getBoundingClientRect || el === m || el.contains(m) || m.contains(el) || el.hasAttribute('data-rd-flohid')) return;
          if (/^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(el.tagName) || (typeof el.className === 'string' && /(^|\s)(rd-|rd3d|capkov)/.test(el.className)) || (el.id && /^PBar|preview-bar/.test(el.id))) return;
          var cs = getComputedStyle(el); if (cs.position !== 'fixed' || cs.display === 'none') return;
          var r = el.getBoundingClientRect();
          if (r.width < 24 || r.height < 24 || r.width > 140 || r.height > 140) return;
          if (r.right < W - 90 || r.bottom < Hh * 0.35) return;
          el.setAttribute('data-rd-flohid', el.style.display || ''); el.style.setProperty('display', 'none', 'important'); floHid.push(el);
        } catch (e) { }
      });
    }
    function floSet(on) {
      if (floTimer) { clearInterval(floTimer); floTimer = 0; }
      if (on) { floScan(); floTimer = setInterval(floScan, 800); return; }
      floHid.forEach(function (el) { var v = el.getAttribute('data-rd-flohid') || ''; el.style.removeProperty('display'); if (v) el.style.display = v; el.removeAttribute('data-rd-flohid'); });
      floHid = [];
    }
    function sync() { var o = m.getAttribute('data-open') === 'true'; document.body.classList.toggle('rd-modal-open', o || !!document.querySelector('.rd3d.is-open')); if (o !== floOn) { floOn = o; floSet(o); } }
    new MutationObserver(sync).observe(m, { attributes: true, attributeFilter: ['data-open'] }); sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindOpenClass, { once: true }); else bindOpenClass();

  /* ---- 3) price in the button ---- */
  function syncPrice() {
    var m = modal(); if (!m) return;
    var v = $('[data-rd-btotal-v]', m), add = $('[data-capkov-add]', m);
    if (!v || !add) return;
    add.setAttribute('data-rd-price', (v.textContent || '').trim());
  }
  function bindPrice() {
    var m = modal(); if (!m) return;
    var v = $('[data-rd-btotal-v]', m); if (!v) return;
    syncPrice();
    if (window.MutationObserver) new MutationObserver(syncPrice).observe(v, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindPrice, { once: true }); else bindPrice();

  /* ---- 4) mobile: sticky "Create embroidery" button whenever the original button is off screen ---- */
  function bindSticky() {
    var open = $('[data-capkov-open]');
    if (!open || !window.matchMedia || !matchMedia('(max-width:820px)').matches) return;
    var line = (open.textContent || '').trim().split(/\n/)[0].trim() || rdOT("capkov.builder.create_embroidery", "Create embroidery");
    var bar = document.createElement('div');
    bar.className = 'rd-stickyopen'; bar.hidden = true;
    bar.innerHTML = '<button type="button" class="rd-btn rd-btn--block">' + line.replace(/[<>&]/g, '') + '</button>';
    document.body.appendChild(bar);
    bar.firstChild.addEventListener('click', function () { open.click(); });
    var inView = false;
    function apply() {
      var m = modal(), opened = m && m.getAttribute('data-open') === 'true';
      bar.hidden = inView || !!opened;
    }
    var raf = 0;
    function check() {
      raf = 0;
      var r = open.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      inView = r.top >= 0 && r.bottom <= vh - 96;
      apply();
    }
    function sched() { if (!raf) raf = requestAnimationFrame(check); }
    window.addEventListener('scroll', sched, { passive: true });
    window.addEventListener('resize', sched);
    check();
    var m = modal();
    if (m && window.MutationObserver) new MutationObserver(apply).observe(m, { attributes: true, attributeFilter: ['data-open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSticky, { once: true }); else bindSticky();
})();

})();
